// removed by extract-text-webpack-plugin
module.exports = {"hero":"src-components-Hero----hero-module---hero---3OE-D","content":"src-components-Hero----hero-module---content---1pOtd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/hero.module.scss
// module id = 345
// module chunks = 168707334958949